import Vue from 'vue';
import Spinner from './spinner.html';

export default Vue.component('ecSpinner', {
	template: Spinner,
	props: {
		loading: Boolean,
	},
});
